/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum CabinClassType {
    First = 'First',
    Business = 'Business',
    PremiumEconomy = 'PremiumEconomy',
    Economy = 'Economy'
}

export function CabinClassTypeFromJSON(json: any): CabinClassType {
    return CabinClassTypeFromJSONTyped(json, false);
}

export function CabinClassTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CabinClassType {
    return json as CabinClassType;
}

export function CabinClassTypeToJSON(value?: CabinClassType | null): any {
    return value as any;
}

